export default __webpack_public_path__ + "static/media/AccioJob.1015e926.png";